import React from "react";
import { getShimmerClass } from "utils/constants/ui";

const BannerLoader = ({ withShimmer }) => {
  const shimmerClass = getShimmerClass(withShimmer);
  return (
    <div className="flex w-100 mv4 flex-column items-center fw5 f3 dib center">
      <div className={`${shimmerClass} h3 mw5 w-100`} />
      <div className={`${shimmerClass} h2 w-100 mt3`} />
      <div className={`${shimmerClass} h2 w-80 mt2`} />
    </div>
  );
};

export default BannerLoader;
